import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { setDefaultOptions } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { FieldInputProps, FormikProps, FormikValues } from 'formik';
import React from 'react';

type Props = {
  field: FieldInputProps<string>;
  form: FormikProps<FormikValues>;
  minDate: Date;
  error: boolean;
  label: string;
};

const DatePicker = ({ field, form, minDate, error, label }: Props) => {
  const { name, value } = field;
  const { setFieldValue } = form;

  React.useEffect(() => {
    setDefaultOptions({
      locale: enUS,
      weekStartsOn: 1,
    });
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MUIDatePicker
        label={label}
        value={value ? new Date(value) : null}
        onChange={(date) => {
          setFieldValue(name, date);
        }}
        format="dd/MM/yyyy"
        minDate={minDate}
        slotProps={{
          textField: {
            variant: 'outlined',
            fullWidth: true,
            error: error,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
